import * as _ from 'lodash';
import { AnyObject, FormApi } from 'final-form';
// import USPSCityState from 'src/models/USPSCityState';
import State from 'src/models/State';

export default class OwnershipFormUtil {
    static alterCityState(states: State[], uspsCityState: AnyObject, form: FormApi, ownerType?: string) {
        // tslint:disable-next-line:max-line-length
        const selectedState =
            states?.length > 0 && uspsCityState?.zipCode.state
                ? states.find((x: State) => x.abbreviation === uspsCityState?.zipCode.state)
                : undefined;
        const selectedCity = uspsCityState?.zipCode.city;

        // const ownershipTypes = ['individualOwner', 'ownerTrust', 'businessOwner', 'bolmOwner', 'ralOwner', 'stateLandOwner'];
        // ownershipTypes.forEach((o: string) => {
        //     form?.change(`${o}.address.city`, selectedCity);
        //     form?.change(`${o}.address.state.id`, selectedStateId);
        // });

        if (ownerType === 'ownerJointTenant') {
            form.change(`${ownerType}.city`, selectedCity);
            form.change(`${ownerType}.state`, selectedState.name);
        }

        form.change(`${ownerType}.address.city`, selectedCity);
        form.change(`${ownerType}.address.state.id`, selectedState.id);
    }
}



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/OwnershipFormUtil.ts